/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { QuestionOptionWithRelations } from './questionOptionWithRelations';
import { AssessmentWithRelations } from './assessmentWithRelations';
import { QuestionAnswerWithRelations } from './questionAnswerWithRelations';
import { AssessmentSectionWithRelations } from './assessmentSectionWithRelations';


/**
 * (tsType: QuestionWithRelations, schemaOptions: { includeRelations: true })
 */
export interface QuestionWithRelations { 
    id?: string;
    questionText: string;
    questionType: string;
    orderIndex: number;
    isRequired: boolean;
    settings?: object;
    assessmentId: string;
    sectionId?: string;
    assessment?: AssessmentWithRelations;
    section?: AssessmentSectionWithRelations;
    options?: Array<QuestionOptionWithRelations>;
    answers?: Array<QuestionAnswerWithRelations>;
}

